/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PostUserControllerRefresh$Params {
}

export function postUserControllerRefresh(http: HttpClient, rootUrl: string, params?: PostUserControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, postUserControllerRefresh.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      }>;
    })
  );
}

postUserControllerRefresh.PATH = '/api/user/refresh';
